import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { nameToUrl } from 'ct-helpers';
import AdItem from '@app/components/GridAdsProject/AdItem/AdItem';
// import AdvertisingWrapper from '@app/components/AdvertisingWrapper';
import LoadMore from '@app/components/GridAdsProject/LoadMore/LoadMore';
import WrapperScroll from '@app/components/WrapperScroll/WrapperScroll';
import theme from 'clad-ui/theme/chotot';
import { config } from '@app/config';
import { styled } from 'linaria/react';
import { getAdParams } from './service/getDataByType';
import styles from '../BannerSlider/styles.module.scss';
import { BlogCate } from './BlogCate/BlogCate';
const TYPES_WITH_ADVERTISING = ['agent', 'project'];
const Wrapper = /*#__PURE__*/styled("div")({
  name: "Wrapper",
  class: "w1gup8gc"
});
const LinearBackground = /*#__PURE__*/styled("div")({
  name: "LinearBackground",
  class: "l1e2bm99"
});
const Grid = /*#__PURE__*/styled("div")({
  name: "Grid",
  class: "gj2em8w"
});
const Title = /*#__PURE__*/styled("h2")({
  name: "Title",
  class: "t39l6v3"
});
const handleBuildUrlViewAd = (adInfo, type, adType = 'sell') => {
  const {
    project_name: projectName,
    project_oid: projectOid,
    address2,
    address = ''
  } = adInfo;
  let regionUrl = '';
  if (address2) regionUrl = address2.split(',');else if (address) regionUrl = address.split(',');
  const subRegionUrl = nameToUrl(regionUrl[0]);
  const prefix = adType === 'sell' ? 'mua-ban' : 'thue';
  let url = `${config.vehicleURL}/du-an/${prefix}-${nameToUrl(projectName)}-${subRegionUrl}-${projectOid}`;
  if (type === 'agent') {
    const adUrl = adInfo.urls[0].url;
    url = `${config.vehicleURL}/cua-hang/${adUrl}`;
  }
  return url;
};
const AdItemFromAdInfo = (adInfo, adListingParams, adItemLocation, type, eventName, mappingFeaturesAdData, handleClickAdView, index) => {
  const adParams = getAdParams(adInfo, adListingParams);
  const adViewUrl = adInfo.url ? adInfo.url : handleBuildUrlViewAd(adInfo, type);
  return <React.Fragment key={`${type}-${adInfo.list_id}-${index}-${adInfo.sticky_ad_type || adInfo.account_id}`}>
      <AdItem adInfo={adInfo} type={type} eventName={eventName} mappingFeaturesAdData={mappingFeaturesAdData} handleClickAdView={handleClickAdView} adViewUrl={adViewUrl} adItemLocation={adItemLocation} adParams={adParams} />
    </React.Fragment>;
};
const renderEventName = type => {
  let eventName = 'job_blog_entry';
  switch (type) {
    case 'blog':
      eventName = 'job_blog';
      break;
    default:
      break;
  }
  return eventName;
};
const GridAdsProject = props => {
  const {
    type,
    title,
    // region,
    isDone = false,
    link,
    ads = [],
    cats = [],
    total,
    // isMobile = false,
    mappingFeaturesAdData,
    handleClickAdView,
    handleClickLoadMore,
    handleClickBlogCate,
    adItemLocation,
    adListingParams,
    accountId
    // isAdBlock,
  } = props;
  const listAdsHtml = [];
  const eventName = renderEventName(type);
  // const listItemWithAdvertising = {};

  for (let i = 0; i < ads.length; i += 1) {
    const ad = ads[i];
    if (TYPES_WITH_ADVERTISING.indexOf(type) > -1) {
      // if (!listItemWithAdvertising || (listItemWithAdvertising && !listItemWithAdvertising[type])) {
      //   listItemWithAdvertising[type] = [];
      //   for (let j = 0; j < ads.length; j++) {
      //     const adWithAdvertising = ads[j];
      //     listItemWithAdvertising[type].push(
      //       AdItemFromAdInfo(
      //         adWithAdvertising,
      //         adListingParams,
      //         adItemLocation,
      //         type,
      //         eventName,
      //         mappingFeaturesAdData,
      //         handleClickAdView,
      //         j
      //       )
      //     );
      //   }
      // }
      listAdsHtml.push(AdItemFromAdInfo(ad, adListingParams, adItemLocation, type, eventName, mappingFeaturesAdData, handleClickAdView, i));
      // if (isAdBlock) {
      // } else {
      //   listAdsHtml.push(
      //     <AdvertisingWrapper
      //       type={type}
      //       eventName={eventName}
      //       position={i}
      //       isMobile={isMobile}
      //       key={`advertising-${type}-${i}`}
      //       listItemWithAdvertising={listItemWithAdvertising[type]}
      //     />
      //   );
      // }
    } else {
      listAdsHtml.push(AdItemFromAdInfo(ad, adListingParams, adItemLocation, type, eventName, mappingFeaturesAdData, handleClickAdView, i));
    }
  }
  return isDone === true && listAdsHtml.length === 0 ? null : <Wrapper id="job-blog-section">
      <Title>{title}</Title>
      {type === 'blog' ? <BlogCate cats={cats} handleClickBlogCate={handleClickBlogCate} /> : null}
      <WrapperScroll eventName={eventName} cols={4.6} total={ads.length} className={styles.oneRowContent} noPadding accountId={accountId}>
        <Grid>
          {!isDone || listAdsHtml.length === 0 ? [<LinearBackground key="LinearBackground_1">
                  <div className="linearImg" />
                  <div className="linearTitle" />
                  <div className="linearTitle" />
                </LinearBackground>, <LinearBackground key="LinearBackground_2">
                  <div className="linearImg" />
                  <div className="linearTitle" />
                  <div className="linearTitle" />
                </LinearBackground>, <LinearBackground key="LinearBackground_3">
                  <div className="linearImg" />
                  <div className="linearTitle" />
                  <div className="linearTitle" />
                </LinearBackground>, <LinearBackground key="LinearBackground_4">
                  <div className="linearImg" />
                  <div className="linearTitle" />
                  <div className="linearTitle" />
                </LinearBackground>] : listAdsHtml}
        </Grid>
      </WrapperScroll>
      {total !== 0 ? <LoadMore type={type} eventName={eventName} link={link} total={total} handleClickLoadmore={handleClickLoadMore} /> : null}
    </Wrapper>;
};
GridAdsProject.propTypes = {
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isDone: PropTypes.bool.isRequired,
  // isMobile: PropTypes.bool.isRequired,
  ads: PropTypes.arrayOf(PropTypes.object).isRequired,
  cats: PropTypes.arrayOf(PropTypes.object),
  mappingFeaturesAdData: PropTypes.shape({}),
  handleClickAdView: PropTypes.func.isRequired,
  handleClickLoadMore: PropTypes.func.isRequired,
  adItemLocation: PropTypes.string,
  adListingParams: PropTypes.arrayOf(PropTypes.object),
  // isAdBlock: PropTypes.bool.isRequired,
  accountId: PropTypes.string.isRequired
};
GridAdsProject.defaultProps = {
  mappingFeaturesAdData: {},
  adItemLocation: '',
  adListingParams: [],
  cats: []
};
export default memo(GridAdsProject);

require("../../../.linaria-cache/src/components/GridAdsProject/GridAdsProject.linaria.module.css");